import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { CIVA_ROAD_BOOKING_STEPS } from '../../../config/constants';
import Badge from '../../common/Badge';
import { changeStepRoadBooking } from '../../../actions';

const RoadBookingNavbar = ({ currentStep, dispatchChangeStepRoadBooking }) => {

  const handleClick = (step) => {
    dispatchChangeStepRoadBooking(step);
  };

  const renderSteps = () => {
    const steps = CIVA_ROAD_BOOKING_STEPS;

    return steps.map((step, index) => {
      // current step is highlighted
      if (index === currentStep)
        return (
          <Col key={step.path}>
            <Badge color="info" text={index + 1} />
            &nbsp;{step.title}
          </Col>
        );
      // future steps are disabled and not clickable
      if (index > currentStep)
        return (
          <Col key={step.path}>
            <Badge color="light" text={index + 1} />
            &nbsp;{step.title}
          </Col>
        );
      // past steps are clickable
      return (
        <Col
          key={step.path}
          onClick={() => {
            handleClick(step);
          }}
          className="clickable"
        >
          <Badge color="success" text={index + 1} />
          &nbsp;{step.title}
        </Col>
      )
    })
  };

  return (
    <div className="p-2 text-center">
      <Row>{renderSteps()}</Row>
    </div>
  )
}

RoadBookingNavbar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  dispatchChangeStepRoadBooking: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
  dispatchChangeStepRoadBooking: changeStepRoadBooking,
}


export default connect(null, mapDispatchToProps)(RoadBookingNavbar);
